<div class="hs-column-type-picker" data-cy="column-type-picker" ngbDropdown>
  <button
    type="button"
    ngbDropdownToggle
    class="btn btn-sm btn-light hs-column-type-toggle"
    [attr.aria-label]="label"
    [attr.data-cy]="'column-type-toggle'"
  >
    <span
      *ngIf="isIconClass(iconFor(currentOption.value)); else glyphIcon"
      [class]="iconFor(currentOption.value)"
      [ngClass]="iconColorClassFor(currentOption.value)"
      class="hs-column-type-icon"
    ></span>
    <ng-template #glyphIcon>
      <span
        class="hs-column-type-icon hs-column-type-glyph"
        [ngClass]="iconColorClassFor(currentOption.value)"
        >{{ iconFor(currentOption.value) }}</span
      >
    </ng-template>
    <span class="hs-column-type-current">{{ currentOption.label }}</span>
    <i class="mdi mdi-chevron-down hs-column-type-caret"></i>
  </button>

  <div ngbDropdownMenu class="hs-column-type-menu" [attr.aria-label]="label">
    <button
      *ngFor="let option of options"
      type="button"
      ngbDropdownItem
      class="hs-column-type-option"
      [class.hs-column-type-selected]="option.value === type"
      [attr.aria-pressed]="option.value === type"
      [attr.data-cy]="'column-type-' + option.value"
      (click)="onPick(option.value)"
    >
      <span
        *ngIf="isIconClass(iconFor(option.value)); else optionGlyphIcon"
        [class]="iconFor(option.value)"
        [ngClass]="iconColorClassFor(option.value)"
        class="hs-column-type-icon"
      ></span>
      <ng-template #optionGlyphIcon>
        <span
          class="hs-column-type-icon hs-column-type-glyph"
          [ngClass]="iconColorClassFor(option.value)"
          >{{ iconFor(option.value) }}</span
        >
      </ng-template>
      <span class="hs-column-type-option-label">{{ option.label }}</span>
      <i
        *ngIf="option.value === type"
        class="mdi mdi-check hs-column-type-check"
      ></i>
    </button>
  </div>
</div>
